export default "__VITE_ASSET__f89de143__"